import React, {FunctionComponent} from 'react';
import './PopupHeader.less';
import {BackButton, BackButtonColors} from 'elements/back-button/BackButton';
import {DrawerTitle} from 'elements/drawer-title/DrawerTitle';
import {DrawerDescription} from 'elements/drawer-description/DrawerDescription.tsx';

interface PopupHeaderProps {
	title: string,
	description?: string | JSX.Element,
	onBackClick?: () => void
	bottomControl?: JSX.Element,
	onExternalLinkClick?: () => void
}

export const PopupHeader: FunctionComponent<PopupHeaderProps> = ({title, description, onExternalLinkClick, onBackClick, bottomControl}) => {
	return <div className="popup-header">
		<div className="popup-header__top-container">
			{
				onBackClick && (<div className="popup-header__back">
					<BackButton onClick={onBackClick} color={BackButtonColors.dark}/>
				</div>)
			}
			<div className="popup-header__header-container">
				{
					title && (
						<div className="popup-header__title">
							<DrawerTitle text={title}/>
						</div>
					)
				}
				{
					description && (
						<div className="popup-header__description">
							<DrawerDescription text={description} onExternalLinkClick={onExternalLinkClick}/>
						</div>
					)
				}
			</div>
		</div>
		{
			bottomControl && (
				<div className="popup-header__bottom-control">
					{bottomControl}
				</div>
			)
		}
	</div>;
};
